module.exports = {
    namespaced: true,
    state: {
        calendar: {},
        filters: {},
        events: [],
    },

    /*
    |--------------------------------------------------------------------------
    | Mutations
    |--------------------------------------------------------------------------
    */
    mutations: {
        addToSelection(state, { key, value }) {
            Vue.set(state.calendar, key, value);
            Vue.set(state.calendar, key, value);
        },
        removeFromSelection(state, key) {
            Vue.delete(state.calendar, key);
        },
        setFilter(state, { filter, value }) {
            Vue.set(state.filters, filter, value);
        },
        setEvents(state, events) {
            Vue.set(state, 'events', events);
        },
    },

    /*
    |--------------------------------------------------------------------------
    | Actions
    |--------------------------------------------------------------------------
    */
    actions: {},

    /*
    |--------------------------------------------------------------------------
    | Getters
    |--------------------------------------------------------------------------
    */
    getters: {
        getScheduleDate: (state) => ({ date }) => {
            return _.find(_.get(state.calendar, `scheduleDates`), (item) => {
                return dateTimeString(item.start) === dateTimeString(date);
            });
        },
        getFilter: (state) => (filter) => {
            return Array.isArray(state.filters[filter]) ? state.filters[filter] : [];
        },
        getEvents: (state) => {
            return _.get(state, 'events', []);
        },
    },
};
